export enum BUSINESS_TYPE {
  POP_UP_STORE = "Pop-up Store",
  ONLINE_ONLY = "Online Only",
  BRICK_AND_MORTAR_SHOP = "Brick & Mortar Store",
  OTHER = "Other",
  BUSINESS_USE = "Business Use",
  CONSUMER = "I Don't Have a Store",
}
